export default "__VITE_ASSET__CPKlip_3__"